<ng-container *ngFor="let w of widgets" axf-widget-renderer [parent]="this" [widget]="w">
</ng-container>
<div class="add-element-container" *ngIf="locked!=true">
    <div class="add-element" (click)="addElement()" >
        <i class="fas fa-plus"></i>&nbsp; Add New Element
    </div>
</div>